var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-main',[_c('el-card',{staticClass:"jumbotron"},[_c('h1',[_vm._v("Password Generator")]),_c('p',[_vm._v("the official tool to generate passwords")]),_c('p',[_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){return _vm.$router.push('/doc')}}},[_vm._v("View Doc")])],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }